import React from "react";
import Logo from "../Assets/logo.png";
import { Link } from "react-router-dom";

export default function Header() {
  return (
    <div className="flex items-center justify-center mt-6">
      <div className="w-11/12">
        <div className="flex items-center justify-between">
          <img className="w-[7.6rem] h-[2.25]" src={Logo} />
          <div className="flex items-center gap-5">
            <Link to="/signin">
              <p className="text-[0.90rem] text-[#111928] font-[500]">Log In</p>
            </Link>
            <Link to="/signup">
              <button className="w-[7.3rem] h-[2.6rem] bg-[#942A27] rounded-[8px] text-white font-[500]">
                Get started
              </button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
